"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
var react_1 = __importDefault(require("react"));
var constants_1 = require("../../assets/js/constants");
var Error = function () {
    return (react_1.default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '50', height: '50', fill: 'none' },
        react_1.default.createElement("path", { fill: constants_1.COLORS.RED, fillRule: 'evenodd', d: 'M17.7 16.3a1 1 0 0 0-1.4 1.4l7.79 7.8-7.8 7.8a1\n                 1 0 0 0 1.42 1.4l7.79-7.79 7.41 7.41a1 1 0 0 0 1.41-1.41l-7.4-7.41\n                 7.4-7.41a1 1 0 0 0-1.41-1.41l-7.41 7.4-7.8-7.79Z', clipRule: 'evenodd' }),
        react_1.default.createElement("rect", { width: '48', height: '48', x: '1', y: '1', stroke: constants_1.COLORS.RED, strokeWidth: '2', rx: '24' })));
};
exports.Error = Error;
